import { render, staticRenderFns } from "./editColisFutur.vue?vue&type=template&id=37e2e1bb&"
import script from "./editColisFutur.vue?vue&type=script&lang=js&"
export * from "./editColisFutur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports